export default __webpack_public_path__ + "static/media/publicBanner02.3d5335b3.jpg";